module.exports = __webpack_public_path__ + "img/iptu-f.ae47a9bb.jpg";